import { useState } from "react"

/**
 * Server-side sorting helper for listing pages that use the shared UpdatedTable.
 *
 * Usage:
 *   const { sortParam, handleServerSort } = useServerSort(() => setPage(1))
 *   // include `${sortParam}` in the fetch query string
 *   // add `sortParam` to the fetch useEffect deps
 *   // pass handleServerSort={handleServerSort} to <UpdateTable />
 *   // mark sortable columns with sortKey:"<db_column>" (or serverField)
 *
 * The table calls handleServerSort(field, "asc"|"desc") on a header click; the
 * API search endpoints already honor sortField/sortOrder (indexed orderBy), so
 * sorting applies across the full dataset and stays fast.
 */
export const useServerSort = (onSortChange) => {
  const [sortField, setSortField] = useState("")
  const [sortOrder, setSortOrder] = useState("")

  const handleServerSort = (field, order) => {
    setSortField(field)
    setSortOrder(order)
    if (onSortChange) onSortChange()
  }

  const sortParam = sortField
    ? `&sortField=${sortField}&sortOrder=${sortOrder}`
    : ""

  return { sortField, sortOrder, sortParam, handleServerSort }
}

export default useServerSort
